var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "live-video-streming-component" }, [
    _vm.videoSrc === "notLoggedIn"
      ? _c("div", { staticClass: "error" }, [
          _c("span", [
            _vm._v(" " + _vm._s(_vm.$t("VideoStreaming.notloggedIn.Message")))
          ])
        ])
      : _vm.videoSrc === "noStreamAvailable"
      ? _c("div", { staticClass: "error" }, [
          _vm._v(
            " " + _vm._s(_vm.$t("VideoStreaming.noStreamAvailable.Message"))
          )
        ])
      : _vm.videoSrc === "noMoneyOrNoPlacedBet"
      ? _c("div", { staticClass: "error" }, [
          _vm._v(
            " " + _vm._s(_vm.$t("VideoStreaming.noMoneyOrNoPlacedBet.Message"))
          )
        ])
      : _vm.videoSrc === "error"
      ? _c("div", { staticClass: "error" }, [
          _vm._v(" " + _vm._s(_vm.$t("VideoStreaming.error.Message")))
        ])
      : _vm.videoSrc
      ? _c("div", { attrs: { id: "liveplayer" } }, [
          _c("video", { attrs: { preload: "", autoplay: "", controls: "" } }, [
            _vm.isMobile
              ? _c("source", {
                  attrs: { src: _vm.videoSrc, type: "application/x-mpegURL" }
                })
              : _c("source", {
                  attrs: { src: _vm.videoSrc, type: "application/dash+xml" }
                })
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d343fb4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d343fb4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/live/LiveVideoStreaming.vue
// module id = null
// module chunks = 